import React from "react";
import Navbar from "../components/Navbar";
import ArticleHero from "../components/ArticleHero";
import { useArticlesContext } from "../context/ArticlesContext";

const Top = (props) => {

    const { articles } = useArticlesContext();
    const referenceArticle = articles.find(
    (art) => art.slug === props.ref_id
  );

  return (
    <>
      <Navbar />
      <ArticleHero
        title={referenceArticle?.title}
        date="February 24, 2025"
        authorName="Edouard Marven"
        // authorLink="#article-birdwatching-author"
        backgroundImage={referenceArticle?.image}
        ariaLabel= {referenceArticle?.image_desc}
      />
    </>
  );
};

export default Top;